// import { EMAIL_VALIDATE_REGEX } from '@/configs/constants';
import { Button } from '@/components/common/Button';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/common/Form';
import { Label } from '@/components/common/Label';
import { Textarea } from '@/components/common/Textarea';
import { useStore } from '@/hooks/useStore';
import yup from '@/services/yup';
import { toastify } from '@/utils/toastify';
import { cn } from '@/utils/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
    id: number
};

export default observer(function RejectForm({ id }: Props) {
    // hooks
    const { t } = useTranslation();

    // store
    const {
        itemStore: { getAllItem, rejectItem, paging, keepSearchParams },
        modalStore: { hideModal }
    } = useStore();

    // validate schema
    const validateSchema = yup.object().shape({
        reason: yup.string().trim().required('form_error_validate.required')
    });
    type FormData = yup.InferType<typeof validateSchema>;
    const form = useForm<FormData>({
        resolver: yupResolver(validateSchema),
        defaultValues: {
            reason: ''
        }
    });

    // state

    // functions
    const onSubmit = async (data?: any) => {
        const newData = {
            id: id,
            payload: data
        };
        const res = await flowResult(rejectItem(newData));
        if (res && res?.ok) {
            toastify('success', '選択されたアイテムは取り下げられました。');
            getAllItem(keepSearchParams, paging);
            hideModal();
        } else {
            toastify('error', res?.message);
        }
    };

    return (
        <>
            <div className=''>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                        <div className='grid grid-cols-1'>
                            <Label className='text-left text-[15px] font-medium' required>{t('field.reason')}</Label>
                            <FormField
                                control={form.control}
                                name='reason'
                                render={({ field }) => (
                                    <FormItem className='mt-2 w-full h-36'>
                                        <FormControl>
                                            <Textarea
                                                maxLength={500}
                                                className='resize-none h-full'
                                                {...field}
                                            />
                                        </FormControl>
                                        <FormMessage className='mt-1' />
                                    </FormItem>
                                )}
                            />
                        </div>
                        <div className='mt-6 flex justify-center items-center space-x-[10px]'>
                            <Button
                                type='button'
                                variant='outline'
                                className={cn('w-[166.5px] text-[15px] font-semibold h-12 hover:text-text-black-1 border border-border-button text-text-black-1 !rounded-[10px]')}
                                onClick={() => hideModal()}
                            >
                                {t('button.no')}
                            </Button>
                            <Button
                                type='submit'
                                variant='active'
                                className={cn('w-[166.5px] text-[15px] font-semibold h-12 bg-active hover:opacity-80 hover:text-white transition-opacity duration-300 !rounded-[10px]')}
                            >
                                {t('button.yes')}
                            </Button>
                        </div>
                    </form>
                </Form>
            </div>
        </>
    );
});
